/* src/app/components/billing/patient-ledger/patient-ledger-list/patient-ledger-list.component.css */
.ledger-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ledger-title {
  margin: 0;
  color: #00504b;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.15;
}
.ledger-search {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ledger-filters {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e5e5;
}
.ledger-filters__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ledger-filters__field label {
  color: #454545;
  font-size: 0.786rem;
  font-weight: 600;
  white-space: nowrap;
}
.ledger-filters__field input,
.ledger-filters__field nz-date-picker {
  min-width: 150px;
}
.ledger-filters__search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  background: #00504b;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ledger-filters__search-btn:hover {
  background: #01796f;
}
.ledger-filters__search-btn:focus-visible {
  outline: 2px solid #10b8ad;
  outline-offset: 2px;
}
.ledger-search__label {
  color: #454545;
  font-size: 0.857rem;
  font-weight: 600;
  white-space: nowrap;
}
.ledger-search__input {
  padding: 8px 12px;
  min-width: 200px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #1f2a2a;
  background: #ffffff;
}
.ledger-search__input:focus {
  outline: 2px solid #10b8ad;
  outline-offset: 1px;
  border-color: #10b8ad;
}
.ledger-search__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  background: #00504b;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ledger-search__btn:hover {
  background: #01796f;
}
.ledger-search__btn:focus-visible {
  outline: 2px solid #10b8ad;
  outline-offset: 2px;
}
.participant-card {
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}
.participant-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  row-gap: 8px;
  column-gap: 24px;
}
.participant-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.participant-field__label {
  color: #454545;
  font-size: 0.857rem;
  font-weight: 400;
}
.participant-field__value {
  color: #20242a;
  font-size: 0.857rem;
  font-weight: 600;
  word-break: break-word;
}
.participant-field__value--mono {
  font-family:
    "Cascadia Code",
    "Consolas",
    "Courier New",
    monospace;
  font-size: 0.786rem;
}
/*# sourceMappingURL=patient-ledger-list.component-WAYDOJ7I.css.map */
